// extracted by mini-css-extract-plugin
module.exports = {"overlay":"FormDescriptionModal_overlay__2Xxh_","modalWindow":"FormDescriptionModal_modalWindow__3K-VG","arrowBack":"FormDescriptionModal_arrowBack__1JV95"};